module.exports = __webpack_public_path__ + "106ae468d9073274f6439211ebed29b2.pdf";